/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";

// import authProfileState from "../../states/authProfileState";

import AccessControl from "../functional/AccessControl";

import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

import notificationState from "../../states/notificationState";

import getSchema from "../../lib/api/getSchema";

import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
// import ApprovalButton from "../input/ApprovalButton";

import { debounce } from "lodash";

import TkInputInspectionContainerCreateButton from "../input/TkInputInspectionContainerCreateButton";
import TkInputInspectionInputButton from "../input/TkInputInspectionInputButton";

function TkInputInspectionContainer(props) {
    const { id, setOnSelectMst, detailEmpty } = props;

    const table = "TkInputInspectionContainer";
    const view = "TkVwInputInspectionContainer";

    const [inputInspectionContainerSchema, setInputInspectionContainerSchema] = useState();
    const [inputInspectionContainerGrid, setInputInspectionContainerGrid] = useState();
    const [inputInspectionContainerApi, setInputInspectionContainerApi] = useState();
    const [inputInspectionContainerDataIsEmpty, setInputInspectionContainerDataIsEmpty] = useState();
    const [inputInspectionContainerSelect, setInputInspectionContainerSelect] = useState();

    const [inputState, setInputState] = useState(false);

    const [, setNotification] = useRecoilState(notificationState);

    // const authProfile = useRecoilValue(authProfileState);

    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setInputInspectionContainerSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        (async () => {
            if (inputInspectionContainerGrid) {
                inputInspectionContainerGrid.selectionChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setInputInspectionContainerSelect(grid.selectedItems[0]);
                        } else {
                            setInputInspectionContainerSelect();
                        }
                    }),
                    10
                );

                inputInspectionContainerGrid.itemsSourceChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setInputInspectionContainerSelect(grid.selectedItems[0]);
                        } else {
                            setInputInspectionContainerSelect();
                        }
                    }),
                    10
                );
            }
        })();
    }, [inputInspectionContainerGrid]);

    useEffect(() => {
        if (inputInspectionContainerSelect) {
            if (inputInspectionContainerSelect.wareHouseCode && inputInspectionContainerSelect.inputDate) {
                setInputState(true);
            } else {
                setInputState(false);
            }
        }
    }, [inputInspectionContainerSelect]);

    useEffect(() => {
        if (inputInspectionContainerSelect) {
            if (setOnSelectMst) {
                setOnSelectMst({
                    inputInspectionContainerId: inputInspectionContainerSelect.inputInspectionContainerId,
                    orderPurchaseId: inputInspectionContainerSelect.orderPurchaseId,
                    inputState: inputState,
                });
            }
        } else {
            if (setOnSelectMst) {
                setOnSelectMst({

                });
            }
        }
    }, [inputInspectionContainerSelect, inputState]);

    // useEffect(() => {

    //     let approvalCtx = {
    //         approvalTypeId: 14,
    //         tableName: "TkInputInspectionContainer",
    //         statusColumn: "approvalStateId",
    //         schema: inputInspectionContainerSchema,
    //         onValidateApprovalItem: (item) => {
    //             if (item.createdBy !== authProfile.username) {
    //                 return [false, t("error.approvalRequesterNotMatch")];
    //             }

    //             return [true, ""];
    //         },
    //         makeRequestItemDescription: (item) => {
    //             return `${t("approvalRequestMsg.msg.eguInputInspection", {
    //                 inputInspectionContainerId: item.inputInspectionContainerId,
    //             })}`; // Use Translation on Production Code
    //         },
    //     };

    //     setApprovalCtx(approvalCtx);

    // }, [inputInspectionContainerSchema, authProfile, t]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    return (
        <BasicCrudScreenType
            id={id}
            table={table}
            view={view}
            headerTitle={t("term.TkInputInspectionContainer")}
            noCreate
            noEdit
            noDelete
            noExcel
            onInitialized={(grid) => {
                grid.selectionMode = "Row";
                setInputInspectionContainerGrid(grid);
            }}
            onApiInitialized={(api) => {
                setInputInspectionContainerApi(api);
            }}
            onLoadData={(data) => {
                setInputInspectionContainerDataIsEmpty(data.length < 1 ? true : false);
            }}
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={inputInspectionContainerSchema && inputInspectionContainerSchema.name}
                        accessMethod="POST"
                    >
                        <TkInputInspectionContainerCreateButton
                            id={id}
                            schema={inputInspectionContainerSchema}
                            color="primary"
                            createButtonName="create"
                            onSuccess={onSuccess}
                            refresh={inputInspectionContainerApi}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={inputInspectionContainerSchema && inputInspectionContainerSchema.name}
                        accessMethod={
                            inputInspectionContainerSchema &&
                            (inputInspectionContainerSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <UpdateRecordButton
                            id={id}
                            schema={inputInspectionContainerSchema}
                            grid={inputInspectionContainerGrid}
                            refresh={inputInspectionContainerApi}
                            disabled={
                                inputInspectionContainerSelect?.approvalState ||
                                inputInspectionContainerDataIsEmpty ||
                                inputState
                            }
                            onSuccess={onSuccess}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={inputInspectionContainerSchema && inputInspectionContainerSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteRecordButton
                            id={id}
                            schema={inputInspectionContainerSchema}
                            grid={inputInspectionContainerGrid}
                            refresh={inputInspectionContainerApi}
                            color="secondary"
                            disabled={
                                inputInspectionContainerSelect?.approvalState ||
                                inputInspectionContainerDataIsEmpty ||
                                !detailEmpty ||
                                inputState
                            }
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onNotifyWarning}
                        />
                    </AccessControl>
                    {/*
                    <AccessControl
                        accessTarget={inputInspectionContainerSchema && inputInspectionContainerSchema.name}
                        accessMethod="APPROVAL"
                    >
                        <ApprovalButton
                            id={id}
                            grid={inputInspectionContainerGrid}
                            refresh={inputInspectionContainerApi}
                            approvalCtx={approvalCtx}
                            disabled={inputInspectionContainerDataIsEmpty}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                        />
                    </AccessControl> */}
                    <AccessControl
                        accessTarget={inputInspectionContainerSchema && inputInspectionContainerSchema.name}
                        accessMethod={
                            inputInspectionContainerSchema &&
                            (inputInspectionContainerSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <TkInputInspectionInputButton
                            id={"TkInputInspectionContainer"}
                            schema={inputInspectionContainerSchema}
                            grid={inputInspectionContainerGrid}
                            refresh={inputInspectionContainerApi}
                            disabled={
                                inputInspectionContainerSelect?.approvalState ||
                                inputInspectionContainerDataIsEmpty ||
                                detailEmpty ||
                                inputState
                            }
                            onSuccess={onSuccess}
                        />
                    </AccessControl>
                    <AccessControl
                        accessTarget={inputInspectionContainerSchema && inputInspectionContainerSchema.name}
                        accessMethod="SAVETOEXCEL"
                    >
                        <SaveToExcelButton
                            id={"TkInputInspectionContainer"}
                            grid={inputInspectionContainerGrid}
                            view={view}
                            color="primary"
                            disabled={inputInspectionContainerDataIsEmpty}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
            exportFormatItem={() => { }}
        />
    );
}

export default TkInputInspectionContainer;
